import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

/** Exchanges the Emergent OAuth session_id for a Plan-Sarthi session. */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState({}, "", window.location.pathname);
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        localStorage.setItem("cx_token", data.access_token);
        setSession(data);
        navigate("/projects", { replace: true });
      })
      .catch(() => navigate("/login?google=failed", { replace: true }));
  }, [location.hash, navigate, setSession]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background" data-testid="auth-callback">
      <Logo size="lg" />
      <p className="text-sm text-muted-foreground">Signing you in…</p>
    </div>
  );
}
